import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import Helmet from "react-helmet";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../../../../Actions/SaveProgressAction";
import { CalculateHieght } from "../../../../../Assets/Js/CustomForm";
import CallOutNew from "../../../../../Component/Headers/callOutNew";
import SelectList from "../../../../../Component/SelectList/SelectList";
import { ValidateMultiselectList } from "../../../../../Utils/Validation";
import "../../index.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "90%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

const marks = () => {
  let i = 0;
  const res = [];
  while (i <= 30) {
    res.push(i);
    i += 1;
  }
  return res.map((x) => ({ value: x, label: JSON.stringify(x) }));
};

function valuetext(value) {
  return `${value}`;
}

class LeaveTransitionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      errors: {},
      isDisabled: false,
      isbuttonclick: false,
      iserrmsg: false,
      errormsg: null,
      criteria: [
        // { displayvalue: 1, displayname: <FormattedMessage id="LbIncreaseToHalf" defaultMessage="Increase to nearest half day" /> },
        {
          displayvalue: 2,
          displayname: (
            <FormattedMessage
              id="LbIncreaseToFull"
              defaultMessage="Increase to nearest full day"
            />
          ),
        },
        // { displayvalue: 3, displayname: <FormattedMessage id="LbDecreaseToHalf" defaultMessage="Decrease to nearest half day" /> },
        {
          displayvalue: 4,
          displayname: (
            <FormattedMessage
              id="LbDecreaseToFull"
              defaultMessage="Decrease to nearest full day"
            />
          ),
        },
        {
          displayvalue: 5,
          displayname: (
            <FormattedMessage
              id="LbDoNotRoundOff"
              defaultMessage="Do not round-off"
            />
          ),
        },
      ],
      selectedCriteria: 2,
      value: 15,
      transition: [],
      isagainbuttonclick: false,
      options: [
        {
          displayvalue: true,
          displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
        },
        {
          displayvalue: false,
          displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
        },
      ],
      ticks: { placement: "after", largeStep: 5, smallStep: 1 },
      tooltip: { placement: "Before", isVisible: true, showOn: "Hold" },
      ticksData: { placement: "Both", largeStep: 1, smallStep: 1 },
      pendingleavedata: null,
      pendingLeaves: [
        {
          displayvalue: 1,
          displayname: (
            <React.Fragment>
              <FormattedMessage
                id="LbManualApproval1"
                defaultMessage={`Let employees/managers deal with pending applications manually, `}
              />{" "}
              <br />
              <FormattedMessage
                id="LbManualApproval2"
                defaultMessage={`initiate carry forward process immediately after they’re settled`}
              />{" "}
            </React.Fragment>
          ),
        },
        // {
        //   displayvalue: 2,
        //   displayname: (
        //     <React.Fragment>
        //       <FormattedMessage
        //         id="LbAutoApproval1"
        //         defaultMessage={`Auto-approve all pending leave applications,`}
        //       />
        //       <br />{" "}
        //       <FormattedMessage
        //         id="LbAutoApproval2"
        //         defaultMessage={`initiate carry forward process immediately after the auto-approvals`}
        //       />{" "}
        //     </React.Fragment>
        //   ),
        // },
      ],
      selectedPendingLeaves: [],
      carryForword: [
        {
          displayvalue: 1,
          displayname: (
            <FormattedMessage
              id="LbAutoCarryForward"
              defaultMessage="Automatically initiate the carry forward process, immediately after the Transition Period ends"
            />
          ),
        },
        {
          displayvalue: 2,
          displayname: (
            <FormattedMessage
              id="LbManualCarryForward"
              defaultMessage="Manually initiate the carry-forward process"
            />
          ),
        },
      ],
      selectedcarryforword: 2,
      startDate: 15,
      endDate: 12,
      selectedIntimation: false,
      leavetransitionid: "",
      enddate: "",
      ListError: false,
      actionidlist: "",
      permissions: { readOnly: false, editable: false },
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.oncarryforwardEncashment = this.oncarryforwardEncashment.bind(this);
    this.onTransitionProcess = this.onTransitionProcess.bind(this);
  }

  DateConversion(startDate, endDate) {
    const startday = new Date(startDate).getDate();
    const startmonth = this.state.month[new Date(startDate).getMonth()];
    const startyear = new Date(startDate).getFullYear();
    startDate = `${startday} ${startmonth} ${startyear}`;
    const endday = new Date(endDate).getDate();
    const endmonth = this.state.month[new Date(endDate).getMonth()];
    const endyear = new Date(endDate).getFullYear();
    endDate = `${endday} ${endmonth} ${endyear}`;
    this.setState({ startDate, endDate });
  }

  DateConversion2(enddate) {
    const endday = new Date(enddate).getDate();
    const endmonth = this.state.month[new Date(enddate).getMonth()];
    const endyear = new Date(enddate).getFullYear();
    enddate = `${endday} ${endmonth} ${endyear}`;
    return enddate;
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.ChangeLanguage("leaveTransition");
    this.getLeaveTransitionDetails();
    this.props.setHelperText({
      helperText: "Helper text regarding leave transition",
      open: false,
    });
    const [isTrue, permissions] = CheckActionPermission("transition");
    if (isTrue) {
      this.setState({ permissions });
    } else {
      // this.props.history.push('404')
    }
  }

  // getLeaveTransitionDetails() {
  //     this.setState({ loading: true }, () => instance.get('/leaves/subscriptionleavetransition').then(result => {
  //         let transition = []
  //         result.data.result.length > 0 ? transition = result.data.result : transition = []
  //         this.setState({ loading: false })
  //     }).catch(error => {
  //         let CommonError = error.response
  //             ? error.response.data.error.message
  //             : error.message;
  //         this.props.enqueueSnackbar(CommonError, { variant: 'error' })
  //     }))
  // }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  UpdateSelectedIntimation(name, HtFeild, selectedItem) {
    this.setState({ [name]: selectedItem.displayvalue });
  }

  getLeaveTransitionDetails() {
    instance
      .get("/leaves/subscriptionleavetransition")
      .then((result) => {
        let transition = [];
        let value;
        let selectedIntimation;
        result.data.result.length > 0
          ? (transition = result.data.result)
          : (transition = []);
        let startDate = transition[0].leavecyclestartdate;
        this.setState({
          pendingleavedata: result.data.result[0].approvalactiontypeid,
        });
        const x = startDate && startDate.split("-");
        x[0] = parseInt(x[0]) + 1;
        x[0] = x[0].toString();
        startDate = x.join("-");
        const enddate = transition[0].leavecycleenddate;
        const endDate = transition[0].leavecycleenddate;
        if (
          transition[0].transitionperiod == null
          // || transition[0].transitionperiod == undefined
        ) {
          value = 15;
        } else {
          value = transition[0].transitionperiod;
        }
        const { leavetransitionid } = transition[0];
        const selectedCriteria = transition[0].leaveroundofftypeid;
        const selectedPendingLeaves = transition[0].approvalactiontypeid;
        const selectedcarryforword = transition[0].carryforwardactiontypeid;
        if (transition[0].isnotifyemployee == null) {
          selectedIntimation = false;
        } else {
          selectedIntimation = transition[0].isnotifyemployee;
        }
        this.setState(
          {
            transition,
            startDate,
            endDate,
            enddate,
            value,
            leavetransitionid,
            // selectedCriteria,
            selectedPendingLeaves,
            // selectedcarryforword,
            selectedIntimation,
          },
          () => {
            this.DateConversion(this.state.startDate, this.state.endDate);
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.leaveTransition[${HtField}]`, "");
    // let text = get(this.props, `Language.leaveTransition[${HtField}]`, "")
    this.props.setHelperText({ helperText: text, open: true });
  }

  UpdateLeaveBalance(selectedIndex) {
    const mailtriggereddays = selectedIndex;
    this.setState({ mailtriggereddays });
  }

  HandleMultiChange = (name, selectedOption) => {
    const index = this.state.selectedOptions.findIndex(
      (item) => item == selectedOption.leavetypeid,
    );
    const { selectedOptions } = this.state;
    if (index != -1) {
      selectedOptions.splice(index, 1);
    } else {
      selectedOptions.push(selectedOption.leavetypeid);
    }
    ValidateMultiselectList(this.state, name);
    this.setState({ selectedOptions }, () => {
      CalculateHieght();
    });
  };

  selHelperText(flag, text) {
    this.props.setHelperText({ helperText: text, open: flag });
  }

  handleChange = (event, value) => {
    console.log("(event, value): ", event, event.value, event.text);
    this.setState({ value });
    const HtField = "HtTransitionPeriod";
    this.HelperSliderFlag([HtField]);
  };

  UpdatePendingLeves(HtField, selectedIndex) {
    this.setState({
      selectedPendingLeaves: selectedIndex.displayvalue,
      PendingLeavesError: false,
    });
    this.HelperSliderFlag([HtField]);
  }

  UpdateCarryForwordLeaves(HtField, selectedIndex) {
    this.setState({
      selectedcarryforword: selectedIndex.displayvalue,
      carryForwardError: false,
    });
    this.HelperSliderFlag([HtField]);
  }

  UpdateCriteria(HtField, selectedIndex) {
    this.setState({
      selectedCriteria: selectedIndex.displayvalue,
      RoundOffError: false,
    });
    this.HelperSliderFlag([HtField]);
  }

  oncarryforwardEncashment() {
    const { transition } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (!issaveinprogress) {
      this.props.enqueueSnackbar(
        "Are you sure you want to begin manual leave transition?",
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              disabled={this.state.isbuttonclick == true ? true : false}
              onClick={() => {
                this.props.closeSnackbar();

                this.setState(
                  {
                    isbuttonclick: true,
                  },
                  () =>
                    instance
                      .post(`leaves/processvalidation`, {
                        fromdate:
                          transition[0] && transition[0].leavecyclestartdate,
                        todate:
                          transition[0] && transition[0].leavecycleenddate,
                      })
                      .then(() => {
                        this.onTransitionProcess();
                      })
                      .catch((error) => {
                        const CommonError = error.response
                          ? error.response.data.error.message
                          : error.message;
                        this.setState({
                          errormsg:
                            "Oops! Looks like some leave applications are still pending. Please take action on pending leave applications and retry.",
                          iserrmsg: true,
                        });
                        // this.props.enqueueSnackbar(CommonError, { variant: "error" });
                        if (this.state.pendingleavedata == 2) {
                          // this.props.setSaveProgress(true);
                          this.props.enqueueSnackbar(
                            `You have enabled auto-approve of all pending leave requests for the FY ${
                              transition[0] && transition[0].leavecyclestartdate
                            } to ${
                              transition[0] && transition[0].leavecycleenddate
                            }. Click on Yes to continue or Cancel to manually review these requests from the request center.`,
                            {
                              variant: "warning",
                              action: [
                                <Button
                                  key="key"
                                  color="inherit"
                                  size="small"
                                  disabled={
                                    this.state.isagainbuttonclick == true
                                      ? true
                                      : false
                                  }
                                  onClick={() => {
                                    this.setState({
                                      isagainbuttonclick: true,
                                    });
                                    this.onTransitionProcess();
                                    this.props.closeSnackbar();
                                  }}
                                >
                                  Yes
                                </Button>,
                                <Button
                                  key="key"
                                  color="inherit"
                                  size="small"
                                  onClick={() => this.props.closeSnackbar()}
                                >
                                  Cancel
                                </Button>,
                              ],
                            },
                          );
                        } else {
                          // this.props.closeSnackbar();
                        }
                      }),
                );

                // );
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              Cancel
            </Button>,
          ],
        },
      );
    }
  }

  onTransitionProcess() {
    this.props.setSaveProgress(true);
    instance.post(`leaves/leavetransitionprocess`, {}).then(
      () => {
        this.props.enqueueSnackbar(
          "Process will be completed within 15 minutes.",
          { variant: "success" },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.props.removeSaveProgress();
        this.props.closeSnackbar();
      },
    );
  }

  onSaveClick() {
    let data = "";
    if (this.state.selectedCriteria == null) {
      this.setState({ RoundOffError: true });
    }
    if (this.state.selectedPendingLeaves == null) {
      this.setState({ PendingLeavesError: true });
    }
    if (this.state.selectedcarryforword == null) {
      this.setState({ carryForwardError: true });
    }

    if (
      this.state.leavetransitionid == null ||
      // this.state.leavetransitionid == undefined ||
      this.state.leavetransitionid == 0
    ) {
      data = {
        leavetransitionid: null,
        transitionperiod: this.state.value,
        leaveroundofftypeid: this.state.selectedCriteria,
        approvalactiontypeid: this.state.selectedPendingLeaves,
        carryforwardactiontypeid: this.state.selectedcarryforword,
        isnotifyemployee: this.state.selectedIntimation,
      };
    } else {
      data = {
        leavetransitionid: this.state.leavetransitionid,
        transitionperiod: this.state.value,
        leaveroundofftypeid: this.state.selectedCriteria,
        approvalactiontypeid: this.state.selectedPendingLeaves,
        carryforwardactiontypeid: this.state.selectedcarryforword,
        isnotifyemployee: this.state.selectedIntimation,
      };
    }
    instance
      .post("/leaves/subscriptionleavetransition", data)
      .then((result) => {
        this.props.enqueueSnackbar("Leave transition saved successfully", {
          variant: "success",
        });
        this.props.removeSaveProgress();
        this.setState({
          isagainbuttonclick: false,
          isbuttonclick: false,
          iserrmsg: false,
        });
        this.getLeaveTransitionDetails();
        // this.props.history.push("./leavetransitionform");
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  add_Days = (add_days, enddate) => {
    const dat = new Date(enddate);
    dat.setDate(dat.getDate() + add_days);

    return this.DateConversion2(dat);
  };

  render() {
    const { transition } = this.state;

    const currentdate = moment(new Date()).format("YYYY-MM-DD");
    const leavecycleenddate = moment(
      transition[0] && transition[0].leavecycleenddate,
    ).format("YYYY-MM-DD");

    return (
      <IntlProvider
        locale="en"
        messages={get(this.props, "Language.leaveTransition", "")}
      >
        <main className="content-outer-wrapper">
          <Helmet>
            <title>{headersList.Config.LeaveCycleTransition.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              {transition &&
                transition[0] &&
                transition[0].istransitiondone == false &&
                leavecycleenddate < currentdate && (
                  <Paper
                    style={{
                      // width: "100%",
                      padding: 16,
                      marginBottom: 16,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className="rounded-rectangle-paper"
                  >
                    <div
                      className=""
                      // onClick={() => this.getOkrData(x.displayvalue, false)}
                      style={{
                        // borderBottom: "1px solid #d8d8d8",
                        padding: "8px 0px",
                      }}
                    >
                      <p className="large-text-dark-secondary  t-bold margin-bottom-4">
                        Manual carry forward & encashment
                      </p>
                      <p className="small-dark-secondary margin-bottom-4">
                        Cycle period:{" "}
                        {transition[0] && transition[0].leavecyclestartdate} to{" "}
                        {transition[0] && transition[0].leavecycleenddate}
                      </p>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={this.oncarryforwardEncashment}
                        // className="btn btn-primary-md-blue margin-top-16"
                        className={
                          this.props.SaveInProgressReducer.issaveinprogress
                            ? "btn btn-primary-md-grey margin-top-16"
                            : "btn btn-primary-md-blue margin-top-16"
                        }
                        disabled={
                          this.props.SaveInProgressReducer.issaveinprogress
                        }
                      >
                        Initiate manual carry forward & encashment
                      </Button>
                      {this.state.iserrmsg && (
                        <CallOutNew
                          classnames="bg-light-red width100 margin-top-16"
                          header={this.state.errormsg}
                          emoji=""
                          textcolor="#f86b07"
                        />
                      )}
                    </div>
                  </Paper>
                )}
              <div
                className="display-flex"
                style={{ justifyContent: "space-between" }}
              >
                <p className="requestCycleLabels margin-bottom-10 labelsSize leave-transition">
                  {" "}
                  <FormattedMessage
                    className="add-label-active requestCycleLabels margin-top-40 margin-bottom-20 labelsSize"
                    id="LbTransitionSettings"
                    defaultMessage="Leave Cycle Transition Settings"
                  />{" "}
                </p>
              </div>

              <Grid container className="configure-cycle-container">
                <Grid item xs={12} md={12} sm={10}>
                  {/* ) : (
                    ""
                  )} */}
                  <p
                    className="Select-the-Long-Leav t-14 ColorBlack inlindClass"
                    tabIndex="0"
                  >
                    <React.Fragment>
                      {" "}
                      <FormattedMessage
                        id="LbTransitionSettingsSentence1"
                        defaultMessage={`These rules will ensure that when your current leave cycle ends on`}
                      />{" "}
                      {<span>{this.state.endDate}</span>}{" "}
                      <FormattedMessage
                        id="LbTransitionSettingsSentence2"
                        defaultMessage={`and a new one begins on`}
                      />{" "}
                      {<span>{this.state.startDate}</span>}{" "}
                      <FormattedMessage
                        id="LbTransitionSettingsSentence3"
                        defaultMessage={`the transition from one cycle to another is free of worries, difficulties and errors.`}
                      />
                    </React.Fragment>
                  </p>
                  {/* <p className="add-label-active requestCycleLabels margin-bottom-20 labelsSize">
                  {" "}
                  <FormattedMessage
                    className="add-label-active requestCycleLabels margin-top-40 margin-bottom-20 labelsSize"
                    id="LbTransitionPeriod"
                    defaultMessage=" Define Transition Period"
                  />{" "}
                </p>

                <div className="control-pane leave-transition">
                  <div className="control-section">
                    <div className="slider-content-wrapper">
                      <Slider
                        className="margin-top-20"
                        // defaultValue={0}
                        getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider-custom"
                        step={1}
                        min={0}
                        max={30}
                        valueLabelDisplay="on"
                        marks={marks()}
                        value={value}
                        onChange={this.handleChange}
                      />


                    </div>
                  </div>
                </div>
                <p className="Select-the-Long-Leav ColorBlack margin-top-40">
                  <FormattedMessage className="margin-top-20 " id="LbPeriod" defaultMessage="Your transition period:" />
                </p>
                <p className="Select-the-Long-Leav ColorBlack ">
                  <FormattedMessage className="margin-top-20 " id="LbPeriodStart" defaultMessage="Starts On:" /> <span> {this.state.endDate}</span>
                </p>
                {this.state.enddate != "" && this.state.enddate != null ? (
                  <p className="Select-the-Long-Leav ColorBlack ">
                    <FormattedMessage className="margin-top-20 " id="LbPeriodEnd" defaultMessage="Ends On:" />{" "}
                    <span> {this.add_Days(parseInt(this.state.value), this.state.enddate)}</span>
                  </p>
                ) : (
                    ""
                  )} */}

                  {/* <p className="add-label-active requestCycleLabels margin-top-20 margin-bottom-10 labelsSize">
                  {" "}
                  <FormattedMessage
                    className="add-label-active requestCycleLabels margin-top-40 margin-bottom-20 labelsSize"
                    id="LbRoundOff"
                    defaultMessage="Round Off"
                  />{" "}
                </p>
                <div className="form-sub-header">
                  {" "}
                  <FormattedMessage
                    className="margin-top-20 "
                    id="LbroundingOff"
                    defaultMessage="Round-off leave balance while carrying forward to the next leave cycle."
                  />
                </div>
                <div className="form-input-label margin-top-10">
                  {" "}
                  <FormattedMessage className="margin-top-20 " id="LbroundingCriteria" defaultMessage="Rounding should happen based on the below criteria" />
                </div>
                <div className="">
                  <SelectList
                    tabIndex="2"
                    data={this.state.criteria}
                    Selected={this.state.selectedCriteria}
                    onSelected={this.UpdateCriteria.bind(this, "HtRoundOff")}
                  />
                  {this.state.RoundOffError == true ? (
                    <span className="caption-error">
                      <FormattedMessage id="ErRoundOff" defaultMessage="Please select leave round-off type 🙏" />
                    </span>
                  ) : (
                      ""
                    )}
                </div> */}
                  <p className="add-label-active requestCycleLabels margin-top-20 margin-bottom-10 labelsSize">
                    {" "}
                    <FormattedMessage
                      className="add-label-active requestCycleLabels margin-top-40 margin-bottom-20 labelsSize"
                      id="LbPendingLeaveApplications"
                      defaultMessage="Pending Leave Applications"
                    />{" "}
                  </p>
                  <div className="form-sub-header">
                    {" "}
                    <FormattedMessage
                      className="margin-top-20 "
                      id="LbHandlePendingLeave"
                      defaultMessage="How do we handle pending leave applications for previous leave cycle?"
                    />
                  </div>
                  <div className="form-input-label margin-top-10">
                    {" "}
                    <FormattedMessage
                      className="margin-top-20 "
                      id="LbPendingLeaveoptions"
                      defaultMessage="When it’s time to initiate ‘Leave Carry Forward Process’, handle all pending leave applications as below:"
                    />
                  </div>
                  <div className="">
                    <SelectList
                      tabIndex="3"
                      data={this.state.pendingLeaves}
                      Selected={this.state.selectedPendingLeaves}
                      onSelected={this.UpdatePendingLeves.bind(
                        this,
                        "HtPendingLeave",
                      )}
                    />
                    {this.state.PendingLeavesError == true ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErRoundOff"
                          defaultMessage="Please select approval action type 🙏"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <p className="add-label-active requestCycleLabels margin-top-20 margin-bottom-10 labelsSize">
                  {" "}
                  <FormattedMessage
                    className="add-label-active requestCycleLabels margin-top-40 margin-bottom-20 labelsSize"
                    id="LbLeaveCarryForward"
                    defaultMessage="Leave Carry Forward Process"
                  />{" "}
                </p>
                <div className="form-sub-header">
                  {" "}
                  <FormattedMessage
                    className="margin-top-20 "
                    id="LbLeaveCarryForwardQue"
                    defaultMessage="How do we initiate the ‘Leave Carry Forward Process'?"
                  />
                </div>
                <div className="form-input-label margin-top-10">
                  {" "}
                  <FormattedMessage
                    className="margin-top-20 "
                    id="LbLeaveCarryForwardProcess"
                    defaultMessage="Schedule or Manually initiate the leave carry-forward process for all types of leaves which have carrying-forward/encashment policies enabled."
                  />
                </div>
                <div className="">
                  <SelectList
                    tabIndex="4"
                    data={this.state.carryForword}
                    Selected={this.state.selectedcarryforword}
                    onSelected={this.UpdateCarryForwordLeaves.bind(this, "HtCarryForwordLeaves")}
                  />
                  {this.state.carryForwardError == true ? (
                    <span className="caption-error">
                      <FormattedMessage id="ErRoundOff" defaultMessage="Please select carry forward action type 🙏" />
                    </span>
                  ) : (
                      ""
                    )}
                </div>
                 */}
                  {/* <div className="add-label-active requestCycleLabels margin-top-20 margin-bottom-10 labelsSize">
                  <FormattedMessage id="LbNotification" defaultMessage="Notification" />
                </div>
                <div className="form-input-label">
                  {" "}
                  <FormattedMessage
                    className="margin-top-20 "
                    id="LbIntimation"
                    defaultMessage="Do you want to intimate employees about lapsed, carry forwarded or encashed leave?"
                  />
                </div> */}
                  {/* <div>
                  <SelectList
                    tabIndex="5"
                    data={this.state.options}
                    Selected={this.state.selectedIntimation}
                    onSelected={this.UpdateSelectedIntimation.bind(this, "selectedIntimation", "HtIntimation")}
                  />
                </div> */}
                </Grid>
              </Grid>
              <div className="draftbutton-wrapper">
                <div className="draftbutton-innerwrapper">
                  {this.state.permissions.editable ? (
                    <span
                      tabIndex="6"
                      className="draftbutton-save cursour-pointer"
                      onClick={this.onSaveClick.bind(this)}
                    >
                      <span
                        className="draft-option1"
                        style={{ marginLeft: 32 }}
                      >
                        Save
                      </span>
                      <DoneAllIcon />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}
        </main>
      </IntlProvider>
    );
  }
}

LeaveTransitionForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SaveInProgressReducer: state.SaveInProgressReducer,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(LeaveTransitionForm)));
